<template>
  <div class="pageContainer">
    <base-card :option="cardOption">
      <div slot="cardBody">
        <div class="dataContainer">
          <div class="top panel">
            <placeholder-list ref="placeholderList"></placeholder-list>
          </div>
          <div class="bottom panel">
            <table-list ref="tableList"></table-list>
          </div>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import baseCard from '@/CrComponents/Card/Card'
import placeholderList from './placeholderList'
import tableList from './tableList'
export default {
  name: 'ConfigList',
  mounted () {

  },
  computed: {},
  components: {
    placeholderList,
    tableList,
    baseCard
  },
  data () {
    return {
      cardOption: {}
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="less">

 .dataContainer {
   .panel{
     height: 400px;
     background-color: #fff;
     padding:10px;
     overflow: auto;
   }
   .top{
     margin-bottom: 10px;
   }

 }
</style>
